import React from 'react';

import {getHost} from '@albert-io/environment';

import SocialButton from '../SocialButton';

import icon from './assets/clever.svg';

function getCleverSocialSignInLink() {
  return `${getHost()}/auth/clever`;
}

interface Props {
  disabled?: boolean;
}

export default function CleverButton({disabled = false}: Props) {
  return (
    <SocialButton disabled={disabled} provider='clever' href={getCleverSocialSignInLink()}>
      <img className='sso-button__logo' src={icon} alt='' />
      &nbsp;Log in with Clever
    </SocialButton>
  );
}
